import React from "react";
import {AccountingRule, AccountingRuleRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {Grid} from "@mui/material";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import FormSelect from "../../../../components/form/form_inputs/form_select";
import FormToggle from "../../../../components/form/form_inputs/form_toggle";
import FormAutocomplete from "../../../../components/form/form_inputs/form_autocomplete";
import {types} from "../../../../components/form/types";

export const AccountingRuleEditPage = () => {
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(AccountingRuleRestControllerApiFactory);

    const form = useForm({
        fetcher: (id) => ctrl.getAccountingRule(id),
        updater: (bean) => ctrl.saveAccountingRule(bean),
        remover: (id) => ctrl.deleteOrDismissAccountingRule(id),
        factory: () => ({active: true} as AccountingRule),
    } as UseFormProps<AccountingRule>);

    return (
        <FormContent form={form} title={"Regla contable"}>
            <Grid container spacing={3}>
                <Grid item sm={4}>
                    <FormSelect
                        field={"event"}
                        label={"Evento"}
                        type={types.accountingRuleEvents}
                    />
                </Grid>
                <Grid item sm={4}>
                    <FormInput field={"taxRate"} label={"% Impuesto"} type="number"/>
                </Grid>
                <Grid item sm={4}>
                    <FormToggle field={"active"} label={"Activa"}/>
                </Grid>
            </Grid>

            <FormAutocomplete
                field={"debitAccount"}
                label={"Cuenta debe (Débito)"}
                type={types.accountingAccounts}
            />

            <FormAutocomplete
                field={"creditAccount"}
                label={"Cuenta haber (Crédito)"}
                type={types.accountingAccounts}
            />

            <FormInput field={"description"} label={"Descripción"} rows={2}/>
        </FormContent>
    );
};
